/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungLayoutDto } from '../../models/aggregierte-auswertung-layout-dto';
import { CreateAggregierteAuswertungLayoutDto } from '../../models/create-aggregierte-auswertung-layout-dto';

export interface UpdateAggregierteAuswertungLayout$Json$Params {
  id: string;
      body?: CreateAggregierteAuswertungLayoutDto
}

export function updateAggregierteAuswertungLayout$Json(http: HttpClient, rootUrl: string, params: UpdateAggregierteAuswertungLayout$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, updateAggregierteAuswertungLayout$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AggregierteAuswertungLayoutDto>;
    })
  );
}

updateAggregierteAuswertungLayout$Json.PATH = '/v1/aggregierteAuswertung/layouts/{id}';
